// import logoImgWhite from '../../assets/images/logo.png';
// import logoImgPurple from '../../assets/images/logo.png';

export const defaultTheme = {
  version: '0.0.2',
  colors: {
    primary: {
      background: '#f4f4f6',
      black: '#000000',
      darkGrey: '#b8b8b8',
      grey: '#d4d4d4',
      lightGrey: '#f6f6f6',
      lighterGrey: '#f0f0f0',
      lilac: '#f6f5ff',
      purple: '#461e7d',
      reddishPink: '#ff2b6e',
      strongPink: '#ff006e',
      textDarkGrey: '#333333',
      textGrey: '#717171',
      violetPurple: '#5738ff',
      white: '#ffffff',
      whiteBoxShadow: '#e2e2e2',
      blueLightGrey: '#c2cbd1',
      navbarActiveColor: '#212529',
      navbarElementBorderBottom: '#d8d8d8',
    },
    status: {
      black: '#000000',
      blue: '#3A16FF',
      cherryRed: '#ec092f',
      darkerGrey: '#828282',
      darkerOrange: '#ff6c40',
      green: '#59bc5f',
      greenBlue: '#00c983',
      grey: '#d4d4d4',
      lightBlue: '#2CFEF9',
      morePink: '#FF006E',
      pink: '#fc4b88',
      pinkRed: '#f33c4d',
      purple: '#461E7D',
      someOtherBlue: '#0070ef',
      successGreen: '#47a52a',
      theOtherGrey: '#cecece',
      violetPurple: '#5738ff',
      warningOrange: '#feb500',
      yellow: '#fecc32',
      stripeEnabled: '#4FD8A4',
      greenishLightBlue: '#60f1c8',
      newYellow: '#F7B500',
      orange: '#FD6600',
    },
    graph: {
      azureLight: '#60f1c8',
      blue: '#0070ef',
      darkPink: '#f33c4d',
      fucsia: '#bd10e0',
      green: '#00cf12',
      lightBlue: '#0099ff',
      orange: '#ff6c40',
      purple: '#461e7d',
      textGrey: '#717171',
      yellow: '#ffe701',
      colorBar1: '#5eab9b',
      colorBar2: '#d58576',
      colorBar3: '#efa469',
      colorBar4: '#a58e9c',
      colorBar5: '#627d78',
    },
    notifications: {
      lightPurple: '#e6e2f5',
    },
    custom: {
      blueCharcoal: '#000103',
      darkGrey: '#4a4a4a',
      dustyGray: '#999999',
      gallery: '#EFEFEF',
      grey: '#929292',
      lighterGrey: '#929292',
      lightGrey: '#dddddd',
      lightPaleGrey: '#eaeef1',
      offWhite: '#cfcfcf',
      paleGrey: '#dbe1e6',
      paleLavender: '#ece8f2',
      tiffany: '#3dd1a0',
      whisper: '#F5F3F8',
      wildSand: '#F5F5F5',
      wisteria: '#b6a3cb',
    },
    widget: {
      borderColor: '#dbe1e6',
    },
  },
  fontset: 'RoobertEnel, sans-serif',
  zIndex: {
    headerFooter: 5000,
    notifyManager: 7001,
    loader: 4999,
    loaderModal: 7001,
    absoluteUp: 9999,
  },

  footer: {
    shadowColor: '#bab9b9',
  },
  input: {
    singleInput: {
      borderColor: '#d4d4d4',
      backgroundColor: '#ffffff',
      placeholderColor: '#717171',
      passwordColor: '#461e7d',
    },
  },
  map: {
    tooltip: {
      colorText: '#212529',
      boxShadow: '#9c9c9c',
    },
    geometryColor: '#f5f5f5',
    labelsTextFill: '#616161',
    labelsTextStroke: '#f5f5f5',
    labelsTextFillAdministrative: '#bdbdbd',
    geometryPoi: '#eeeeee',
    geometryPoiTextField: '#757575',
    geometryPark: '#e5e5e5',
    geometryParkTextField: '#9e9e9e',
    road: '#ffffff',
    roadArterial: '#757575',
    roadHighway: '#dadada',
    roadHighwayText: '#616161',
    roadLocal: '#9e9e9e',
    geometryTransitLine: '#e5e5e5',
    geometryTransitStation: '#eeeeee',
    water: '#c9c9c9',
    waterText: '#9e9e9e',
  },
};

export default defaultTheme;
